export const API_VERSIONS = {
  V1: 'v1',
  V2: 'v2'
}

export const isDocumentsApiV2 = () => {
  const clientData = JSON.parse(localStorage.getItem('clientData') || '{}')
  return clientData.documentsApiVersion === API_VERSIONS.V2
}